@if (heading) {
    <div class="faq-wrapper">
        <div class="faq-layout">
            <!-- Fælles divider for heading, links og hjælp -->
            <div class="faq-rail" aria-hidden="true">
                <span class="faq-rail-orange"></span>
            </div>

            <div class="faq-content">
                <div class="title">
                    <h4 class="pb10 body-header" [innerHTML]="heading | translate"></h4>
                </div>

                <div class="faq-items">
                    @for (link of faqLinks$ | async; track link) {
                        <a
                            [href]="link.href"
                            title=""
                            target="_blank"
                            rel="noopener noreferrer"
                            class="small faq-link"
                            (click)="onLinkClick(link)"
                        >
                            <span class="faq-link-text" [innerHTML]="link.text"></span>
                        </a>
                    }

                    @if (helpEmail) {
                        <div class="help-email">
                            <span class="small help-email-content">
                                {{ 'capacitySubmission.helpEmail' | translate }}
                            </span>
                            <a
                                class="small help-email-link"
                                [href]="'mailto:' + helpEmail"
                                [attr.aria-label]="'capacitySubmission.helpEmailAriaLabel' | translate"
                            >
                                {{ helpEmail }}
                            </a>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
